import { useEffect, useState } from "react";
import { useMerchantApiQuery, useShowOnboardingRequired } from "../../hooks";
import { IOnboardingStatus } from "../../interfaces-and-types";
import { View } from "./View";

interface IActivationRequiredWarning {
  title: string;
  subtitle: string;
  urlTarget: string;
  // icon?: string;
}

export const ActivationRequiredWarning = (
  props: IActivationRequiredWarning
) => {
  const { showOnboardingRequired, onboardingStatus } =
    useShowOnboardingRequired();

  const showOriginalMessage =
    !onboardingStatus?.is_account_activation_requested &&
    !onboardingStatus?.is_account_verification_completed;

  const statusColor = showOriginalMessage ? "danger" : "warning";

  const title = showOriginalMessage
    ? props.title
    : "Your profile is being verified";

  const subtitle = showOriginalMessage
    ? props.subtitle
    : "Our team is currently checking the details you provided. Your account will be activated once the checks are complete.";

  const urlTarget = showOriginalMessage ? props.urlTarget : "#";

  return (
    <View
      title={title}
      subtitle={subtitle}
      urlTarget={urlTarget}
      statusColor={statusColor}
      showOnboardingRequired={showOnboardingRequired}
    />
  );
};
